import { render } from "./InstallInstructions.vue?vue&type=template&id=5d6aec65&scoped=true"
import script from "./InstallInstructions.vue?vue&type=script&lang=js"
export * from "./InstallInstructions.vue?vue&type=script&lang=js"

import "./InstallInstructions.vue?vue&type=style&index=0&id=5d6aec65&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6aec65"]])

export default __exports__